import { ConditionalDynamicDisplayElement } from '../base/conditional-dynamic-display-element';
export class EllipseElement extends ConditionalDynamicDisplayElement {
    constructor(element, permissionChecker, variableCommunicator, variableStore) {
        super(element, permissionChecker, variableCommunicator, variableStore);
    }
}
